
<div
    v-if="value && numbers"
    class="w-100 lm-border pa-3"
    style="position: relative"
>
    <div class="create-button" >
        <v-btn
            v-if="createAllowed"
            color  = "primary"
            @click = "onCreate"
            fab
            x-small
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
    <v-row content="no-frame">
        <v-col class="no-frame">
            <slot name="pre"></slot>
        </v-col>
    </v-row>

    <draggable
        tag    = "ul"
        :list  = "numbers"
        class  = "list-group"
        handle = ".handle"
        @change="onChanged"
    >
        <transition-group type="transition" name="flip-list">
        <li
            class="list-group-item"
            v-for="(number, index) in numbers"
            :key="'number' +index"
        >
            <f-phone-number
                v-model = "number.value"
                class   = "w-100"
                @delete = "onDelete(index)"
                @input  = "onChanged"
            />
        </li>
        </transition-group>
    </draggable>
</div>
